import { render } from "./Tem015.vue?vue&type=template&id=41ca2fdf"
import script from "./Tem015.vue?vue&type=script&lang=js"
export * from "./Tem015.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__